import React, { useState, useEffect } from 'react'
import { CommonInput, CommonModal } from 'components'

const AddBalanceContinueModal = (props) => {
    const { form, setForm } = props;
    const [selectedMode, setSelectedMode] = useState(1000);

    const paymentModes = [
        { value: 1000, label: '₹ 1000' },
        { value: 2000, label: '₹ 2000' },
        { value: 3000, label: '₹ 3000' },
        { value: 4000, label: '₹ 4000' }
    ];

    // Prefill the form with the initial selected amount
    useEffect(() => {
        if (!form.amount) {
            setForm({ ...form, amount: selectedMode.toString() });
        }
    }, []);

    // Watch for manual amount change — unselect button if mismatch
    useEffect(() => {
        const numericAmount = parseFloat(form.amount);
        const isPreset = paymentModes.some(mode => mode.value === numericAmount);
        if (!isPreset) {
            setSelectedMode(null);
        } else {
            setSelectedMode(numericAmount);
        }
    }, [form.amount]);

    const handleModeClick = (value) => {
        setSelectedMode(value);
        setForm({ ...form, amount: value.toString() });
    };

    const propsLrModalInhance = {
        ...props,
        title: 'Recharge Wallet',
        disabled: !form.amount || parseFloat(form.amount) <= 0,
        modalMainClass: "addbalance",
    }

    return (
        <div>
            <CommonModal {...propsLrModalInhance}>
                <div className='addLr_body'>
                    {/* Amount Input */}
                    <div style={{ marginBottom: '24px' }}>
                        <CommonInput
                            label="Amount"
                            placeholder="Enter Amount"
                            value={form.amount}
                            onChange={(e) => setForm({ ...form, amount: e.target.value })}
                        />
                    </div>

                    {/* Payment Mode Section */}
                    <div style={{ marginBottom: '24px' }}>
                        <label style={{ 
                            display: 'block', 
                            fontSize: '14px', 
                            fontWeight: '500', 
                            color: '#374151',
                            marginBottom: '12px' 
                        }}>
                            Payment Mode to Party
                        </label>
                        <div style={{ 
                            display: 'grid', 
                            gridTemplateColumns: 'repeat(4, 1fr)', 
                            gap: '12px' 
                        }}>
                            {paymentModes.map((mode) => (
                                <button
                                    key={mode.value}
                                    onClick={() => handleModeClick(mode.value)}
                                    style={{
                                        padding: '12px 8px',
                                        borderRadius: '8px',
                                        border: selectedMode === mode.value 
                                            ? '2px solid #2563eb' 
                                            : '2px solid #d1d5db',
                                        backgroundColor: selectedMode === mode.value 
                                            ? '#eff6ff' 
                                            : '#ffffff',
                                        color: selectedMode === mode.value 
                                            ? '#2563eb' 
                                            : '#374151',
                                        fontWeight: '500',
                                        cursor: 'pointer',
                                        transition: 'all 0.2s',
                                        fontSize: '14px'
                                    }}
                                    onMouseEnter={(e) => {
                                        if (selectedMode !== mode.value) {
                                            e.target.style.borderColor = '#9ca3af';
                                        }
                                    }}
                                    onMouseLeave={(e) => {
                                        if (selectedMode !== mode.value) {
                                            e.target.style.borderColor = '#d1d5db';
                                        }
                                    }}
                                >
                                    {mode.label}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
            </CommonModal>
        </div>
    )
}

export default AddBalanceContinueModal
